import React from 'react'
import { menuItemParams } from '../../../../types'
import style from './style.module.scss'

type parentSubMenuParams = {
    item: menuItemParams
}

const ParentSubMenu: React.FC<parentSubMenuParams> = ({ item }) => {
    const { url, target, title } = item

    return url && url !== '#' ? (
        <a href={url} target={target} className={style.item}>
            {title}
        </a>
    ) : (
        <div className={style.item}>{title}</div>
    )
}

export default ParentSubMenu
